import type { Route } from '@angular/router';
import {
  sequentialDeactivateGuards,
  hasStringPathParamCanActivateGuard,
} from '@pct-ng/core/router';
import { showToasterDeactivateGuard } from '@pct-ng/form';
import { dirtyCheckCanDeactivateGuard } from '@pct-ng/feature-dirty-check';

export const offerCategoryRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/offer-category-list.component').then(
        ({ OfferCategoryListComponent }) => OfferCategoryListComponent,
      ),
    pathMatch: 'full',
  },
  {
    path: 'new',
    loadComponent: () =>
      import('./details/offer-category-details.component').then(
        ({ OfferCategoryDetailsComponent }) => OfferCategoryDetailsComponent,
      ),
    title: 'PAGES.OFFER.CATEGORY.BREADCRUMB.NEW',
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.OFFER.CATEGORY.SINGULAR'),
      ]),
    ],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./details/offer-category-details.component').then(
        ({ OfferCategoryDetailsComponent }) => OfferCategoryDetailsComponent,
      ),
    title: 'PAGES.OFFER.CATEGORY.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.OFFER.CATEGORY.SINGULAR'),
      ]),
    ],
  },
];
